import { Link } from 'react-router-dom'
import { HARDWARE_BUILDS } from '../../data/hardwareBuilds'

export function BuildProjectListView() {
  return (
    <div className="page page--build-list">
      <header className="build-list-header">
        <Link to="/hardware" className="btn-back" aria-label="Back to hardware store">←</Link>
        <h1 className="page-title">🪚 What do you want to build?</h1>
      </header>
      <p className="build-list-intro">
        Tap a project. Follow the steps in the app – and you can build it in real life too!
      </p>
      <ul className="build-list-grid" aria-label="Build projects">
        {HARDWARE_BUILDS.map((project) => (
          <li key={project.id}>
            <Link
              to={`/hardware/build/${project.id}`}
              className="build-list-card"
              aria-label={`Build ${project.name}`}
            >
              <span className="build-list-card-emoji" aria-hidden>{project.emoji}</span>
              <span className="build-list-card-name">{project.name}</span>
              {project.description && (
                <span className="build-list-card-desc">{project.description}</span>
              )}
              <span className="build-list-card-steps">{project.steps.length} steps</span>
            </Link>
          </li>
        ))}
      </ul>
      <Link to="/hardware" className="btn-large btn-secondary" style={{ textDecoration: 'none', marginTop: 24 }}>
        Back to Hardware Store
      </Link>
    </div>
  )
}
